import React, { useState } from 'react';
import Tab from '../components/tab';
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useSelector } from 'react-redux';

export default function Skill2({ nextStep, prevStep, setStep }) {
  const [hasSkills, setHasSkills] = useState(null);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  let Yes = () => {
    setHasSkills(true);
    nextStep();
  }

  let No = () => {
    setHasSkills(false);
    setStep(16);
  }
  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 lg:gap-0 h-max lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md py-10 px-6 md:px-8 md:py-8 `}>

        <div className='flex justify-center w-full'>
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <Tab num="3" current={true} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        <div className='flex justify-center w-full'>
          <div className='flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center'>
            <p className="text-center text-black font-semibold notranslate">
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["¿Te gustaría agregar habilidades técnicas a la lista?"]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Would you like to add job-specific skills to the list?"]} loop={1} typeSpeed={40} />
              )}
            </p>
            {/* <Typewriter words={["Would you like to add job-specific skills to the list?"]} loop={1} typeSpeed={40} /></p> */}

            <motion.div 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut", delay: 1.5 }} 
            //   className='relative w-full flex p-6 flex-col border border-[#FF6633] gap-2 rounded-md'
            >
            <p className="text-center text-black font-semibold py-2 notranslate" key={flowLanguage}>
              {flowLanguage == "Spanish" ? (
                "(Por ejemplo: limpieza, construcción, servicio al cliente, etc.)"
              ) : (
                "(For example: cleaning, construction, customer service, etc.)"
              )}                
            </p>
            <div className='flex w-full flex-col lg:flex-row gap-8 justify-center'>
              <button
                onClick={Yes}
                className={`px-8 py-3 rounded-md flex gap-x-6 items-center justify-between lg:justify-start font-medium ${hasSkills === true
                  ? 'bg-[#5843BD] text-white'
                  : 'border border-[#5843BD] text-[#5843BD]'
                  }`}
              >
                YES
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="12" fill="#927BFF" />
                  <path d="M10.0645 16.9866C9.88017 16.9972 9.69569 16.9684 9.52337 16.9021C9.35105 16.8359 9.19485 16.7336 9.06515 16.6022C7.73332 15.2723 6.40277 13.9411 5.0735 12.6086C4.52289 12.0532 4.5267 11.2441 5.05905 10.7099C5.5914 10.1756 6.40436 10.1881 6.95784 10.7368C7.92709 11.6939 8.88993 12.6577 9.84637 13.6282C10.0078 13.7925 10.0904 13.7944 10.2595 13.6388C12.5074 11.567 14.7589 9.49944 17.0138 7.43603C17.3367 7.13911 17.699 6.9623 18.141 7.01803C18.6964 7.08818 19.0856 7.39375 19.2624 7.92418C19.4392 8.4546 19.3056 8.93699 18.8992 9.31847C18.1871 9.99111 17.4578 10.6417 16.7409 11.3028C14.8326 13.0516 12.9245 14.8011 11.0167 16.5513C10.7313 16.8107 10.42 16.9981 10.0645 16.9866Z" fill="white" />
                </svg>
              </button>
              <button
                onClick={No}
                className={`px-8 py-3 rounded-md  flex gap-x-6 items-center justify-between lg:justify-start font-medium ${hasSkills === false
                  ? 'bg-[#FF6633] text-white'
                  : 'border border-[#FF6633] text-[#000]'
                  }`}
              >
                NO
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="12" fill="#FF6633AD" />
                  <path d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z" fill="white" />
                </svg>
              </button>
            </div>
            </motion.div>
          </div>
        </div>


        <Footer nextStep={nextStep} prevStep={prevStep} showNext={false} />
      </div>
    </div>
  );
}